"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_router_1 = require("vue-router");
var services_1 = require("./services");
var routes = [
    {
        path: '/tsas',
        name: 'tsas',
        component: function () { return Promise.resolve().then(function () { return require('./layouts/wrapper/WrapperLayout.vue'); }); },
        children: [
            {
                path: 'admin',
                name: 'admin',
                component: function () { return Promise.resolve().then(function () { return require('./layouts/user/UserLayout.vue'); }); },
                meta: {
                    requiresAuth: true,
                },
                children: [
                    {
                        path: 'dashboard',
                        name: 'dashboard',
                        component: function () { return Promise.resolve().then(function () { return require('./views/admin/Dashboard.vue'); }); },
                    },
                    {
                        path: 'orders',
                        name: 'orders',
                        meta: { title: 'Orders' },
                        component: function () { return Promise.resolve().then(function () { return require('./layouts/wrapper/WrapperLayout.vue'); }); },
                        children: [
                            {
                                path: 'details/:id',
                                name: 'orderDetail',
                                meta: { title: 'Order Details' },
                                component: function () { return Promise.resolve().then(function () { return require('./views/admin/OrderDetails.vue'); }); },
                            },
                            {
                                path: '',
                                component: function () { return Promise.resolve().then(function () { return require('./views/admin/Orders.vue'); }); },
                            },
                        ],
                    },
                    {
                        path: '',
                        component: function () { return Promise.resolve().then(function () { return require('./views/admin/Dashboard.vue'); }); },
                    },
                    {
                        path: '/:pathMatch(.*)*',
                        redirect: '/tsas/login',
                    },
                ],
            },
            {
                path: 'login',
                name: 'authentication',
                component: function () { return Promise.resolve().then(function () { return require('./layouts/authentication/AuthenticationLayout.vue'); }); },
                meta: {
                    hideForAuth: true,
                },
                children: [{ path: '', component: function () { return Promise.resolve().then(function () { return require('./views/login.vue'); }); } }],
            },
            {
                path: '',
                redirect: '/tsas/login',
            },
        ],
    },
];
var router = vue_router_1.createRouter({
    history: vue_router_1.createWebHistory(),
    routes: routes,
});
router.beforeEach(function (to, _, next) {
    if (to.matched.some(function (record) { return record.meta.requiresAuth; })) {
        if (services_1.sessionService.isAuthenticated()) {
            next();
            return;
        }
        next('/tsas/login');
        return;
    }
    if (to.matched.some(function (record) { return record.meta.hideForAuth; }) && services_1.sessionService.isAuthenticated()) {
        next('/tsas/admin');
        return;
    }
    next();
});
exports.default = router;
